import { Box, Card, CardContent, CardMedia } from '@mui/material';
import { grey } from '@mui/material/colors';
import makeStyles from '@mui/styles/makeStyles';
import { uicolors } from '../../theme';
import { AdData } from '../../types';
import { DisplayMarkup } from '../display-markup';

const useStyles = makeStyles((theme) => ({
  cardWrapper: {
    display: 'block',
    height: '100%',
    minHeight: 330,
    width: '245px',
    backgroundColor: grey[900],
    borderRadius: 5,
    textDecoration: 'none',
    color: 'inherit',
    boxShadow: `0px 3px 5px ${grey[900]}`,
    '&:hover': {
      cursor: 'pointer',
      transform: 'scale(1.03)',
      zIndex: 100,
    },
    [theme.breakpoints.down('lg')]: {
      width: '235px',
    },
    [theme.breakpoints.only('sm')]: {
      width: '220px',
    },
  },
  cardImage: {
    width: '100%',
    height: '100%',
    maxHeight: 150,
    objectFit: 'contain',
    padding: 5,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#2c2c2c',
    [theme.breakpoints.down('lg')]: {
      maxHeight: 125,
    },
  },
  cardContent: {
    fontFamily: 'Lato',
    height: '100%',
    minHeight: 180,
    lineHeight: 1.2,
    color: uicolors.blueNav[950],
    backgroundColor: '#fff',
  },
  carouselTitle: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  description: {
    fontSize: 14,
    marginTop: 5,
  },
}));

export function FooterAdItem(props: { data: AdData }) {
  // Props
  const { data } = props;
  // Hooks
  const classes = useStyles();

  return (
    <Box p={2}>
      <Card
        key={data.AdId}
        className={classes.cardWrapper}
        component="a"
        href={data.ActionLink}
        target={
          !data.ActionLink.includes('https:') ||
          data.ActionLink.includes(window.location.host)
            ? '_self'
            : '_blank'
        }
        rel="noopener noreferrer"
      >
        <CardMedia
          component="img"
          image={data.ImageURL}
          alt={data.Name}
          className={classes.cardImage}
          style={{
            backgroundImage: `linear-gradient(to top,${
              data.BGColor || '#2196f3'
            } ,${data.BGColor || '#2196f3'}40)`,
          }}
        />
        <CardContent className={classes.cardContent}>
          <Box className={classes.carouselTitle}>{data.Name}</Box>
          <Box>
            <DisplayMarkup
              markup={data.Description}
              className={classes.description}
            />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
